module.exports = __webpack_public_path__ + "static/img/013.e6e9bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/013.png
// module id = N1FP
// module chunks = 1